import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Sayfa başlıklarındaki tek geri tuşu.
 *
 * Panelde altı ayrı geri tuşu biçimi vardı (btn-light + "Geri Dön", secondary
 * rounded-pill, ikon-only btn-sm, sayfaya özel `back-btn` sınıfı, outline "Geri",
 * chevron + "Geri"). Bu bileşen hepsinin yerine geçer; görünüm tek yerden değişir.
 *
 * Varsayılan davranış tarayıcı geçmişinde bir adım geri gitmektir. Hedef sabit
 * olmalıysa `to` verilir (ör. akış ortasında geçmişe dönmek kullanıcıyı formun
 * içine geri atar); özel bir iş yapılacaksa `onClick` verilir ve o kazanır.
 *
 * @param {string}   [to]        Sabit hedef yol. Verilmezse navigate(-1).
 * @param {Function} [onClick]   Kendi geri davranışın; verilirse `to` yok sayılır.
 * @param {string}   [label]     Buton metni. null verilirse yalnız ikon çizilir.
 * @param {string}   [className] Ek sınıf (konumlandırma için: mb-3 vb.).
 */
const BackButton = ({ to, onClick, label = "Geri Dön", className = "", ...rest }) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
            return;
        }
        if (to) {
            navigate(to);
            return;
        }
        navigate(-1);
    };

    return (
        <button
            type="button"
            className={`btn btn-light btn-rounded d-flex align-items-center justify-content-center px-3 ${className}`.trim()}
            style={{ height: 34, flexShrink: 0 }}
            onClick={handleClick}
            title={label || "Geri dön"}
            {...rest}
        >
            <i className={`bx bx-arrow-back${label ? " me-1" : ""}`} style={{ fontSize: 16 }} />
            {label}
        </button>
    );
};

export default BackButton;
